import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { RequirementSectionDataService } from "../../core/requirementsections.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import * as dataCore from "../../core/datacore";
import * as fileHelper from "../../shared/file.helper";
import { AuthServerProvider } from "../../shared/auth/auth.service";
import { ConfirmDialog } from "../../shared/confirm-dialog.component";
import { map } from "rxjs/operators";

@Component({
    selector: "crew-edit-requirementsection",
    template: require('./requirement-section.edit.component.html')
})
export class EditRequirementSection extends EditBase<Nema.Crew.Model.CompetenceRequirementCollection, RequirementSectionDataService> {

    public ValidFrom: Date;
    public ExpirationDate: Date;

    public get checkValidFrom(): boolean {
        return !this.ValidFrom;
    }

    public get checkExpiration(): boolean {
        return !this.ExpirationDate;
    }

    public hasExistingFile: boolean;
    private newFile: File = null;
    private shouldRemoveExistingFile: boolean = false;

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('requirementSection') requirementSectionEntity: Nema.Crew.Model.CompetenceRequirementCollection,
        @Inject("authorities") public authorities: Nema.Crew.Model.Authority[],
        @Inject("workplaces") public workplaces: Nema.Crew.Model.Workplace[],
        @Inject(RequirementSectionDataService.Id) requirementSectionDataService: RequirementSectionDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('authServerProvider') private authServerProvider: AuthServerProvider,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, requirementSectionEntity, requirementSectionDataService, $log, isNew);

        if (!isNew) {
            (<any>this.entity.CompetenceRequirementCollectionWorkplaces).load();
        }

        this.ValidFrom = dataCore.addTimezoneOffset(this.entity.ValidFrom);
        this.ExpirationDate = dataCore.addTimezoneOffset(this.entity.Expiration);

        this.hasExistingFile = !!this.entity.AttachmentFileContentId;
    }

    public entityDisplayName = "Requirement Section";

    public listStateName = "app.settings.requirementsections";

    public save(): Promise<void> {
        return this.shouldProceedWithSave()
            .then(res => {
                if (res) {
                    return this.proceedWithSave();
                }
            });
    }
    private shouldProceedWithSave(): Promise<boolean> {
        if (this.entity.CompetenceRequirementCollectionWorkplaces.length) {
            return Promise.resolve(true);
        }

        let dialogRef = this.dialog.open(ConfirmDialog);

        dialogRef.componentInstance.content = "No workplaces have been added, do you want to continue?";

        return dialogRef
            .afterClosed()
            .pipe(map(res => !!res))
            .toPromise();
    }

    private proceedWithSave(): Promise<void> {
        this.entity.ValidFrom = dataCore.subtractTimezoneOffset(this.ValidFrom);
        this.entity.Expiration = dataCore.subtractTimezoneOffset(this.ExpirationDate);

        return super.save();
    }

    protected saveNew(): Promise<any> {
        return super.saveNew()
            .then(res => this.entity = <any>res.entities[0]);
    }

    protected afterEntitySave(): Promise<any> {
        return super.afterEntitySave()
            .then(() => this.saveOrDeleteFile())
            .then(() => this.dataService.get(this.entity.Id))
            .then(res => this.entity = res)
            .then(() => this.dataService.getAll());
    }

    private saveOrDeleteFile(): Promise<any> {
        return new Promise<any>(
            resolve => {
                if (this.newFile) {
                    resolve(this.dataService.saveFileContent(this.newFile, fileHelper.getRequirementSectionFileDownloadUrl(this.entity.Id)));
                } else if (this.hasExistingFile && this.shouldRemoveExistingFile) {
                    resolve(this.dataService.deleteFileContent(fileHelper.getRequirementSectionFileDownloadUrl(this.entity.Id)));
                } else {
                    resolve();
                }
            });
    }

    public setNewFile(file: File): void {
        this.newFile = file;
    }

    public downloadFile(): void {
        const jwtToken = this.authServerProvider.getToken();

        if (jwtToken) {
            window.open(fileHelper.getRequirementSectionFileDownloadUrl(this.entity.Id) + "?jwtToken=" + jwtToken);
        } else {
            window.open(fileHelper.getRequirementSectionFileDownloadUrl(this.entity.Id));
        }
    }

    public setExistingFileShouldBeRemoved(): void {
        this.shouldRemoveExistingFile = true;
    }

    public addWorkplace(): void {
        var newWorkplace = this.dataService.newRequirementSectionWorkplace(this.workplaces[0].Id);
        this.entity.CompetenceRequirementCollectionWorkplaces.push(<any>newWorkplace);
    }

    public removeWorkplace(requirementSectionWorkplace: Nema.Crew.Model.CompetenceRequirementCollectionWorkplace): void {
        var index = this.entity.CompetenceRequirementCollectionWorkplaces.indexOf(requirementSectionWorkplace, 0);
        if (index > -1) {
            var requirementSectionWorkplaceToDelete = this.entity.CompetenceRequirementCollectionWorkplaces[index];
            this.dataService.removeMapping(requirementSectionWorkplaceToDelete, () => this.entity.CompetenceRequirementCollectionWorkplaces.splice(index, 1));
        }
    }

    public getTodayOrNull(checked: boolean): Date {
        return dataCore.getTodayOrNull(checked);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirementsections/requirement-section.edit.component.ts